import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type { GridFilterModel, GridSortModel } from '@mui/x-data-grid';
import {
  DIAM_API_PATH,
  DiamInvitationFilter,
  DiamPageSortField,
  getInvitationsPage,
} from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';
import {
  buildInvitationsPageFilter,
  toDiamSortFields,
} from '../../diamGridUtils';

export const INVITATIONS_FILTER: DiamInvitationFilter = {};

export interface UseInvitationsPageParams {
  page: number;
  pageSize: number;
  sortModel: GridSortModel;
  filterModel: GridFilterModel;
}

const DEFAULT_SORT: DiamPageSortField[] = [
  { field: 'createdDate', direction: 'DESC' },
];

export function useInvitations({
  page,
  pageSize,
  sortModel,
  filterModel,
}: UseInvitationsPageParams) {
  const { getIdToken, apiUrl, isSignedIn } = useApiEssentials(DIAM_API_PATH);
  const filter = buildInvitationsPageFilter(filterModel);
  const sort = toDiamSortFields(sortModel, DEFAULT_SORT);

  return useQuery({
    queryKey: [
      'diam',
      'invitations',
      'page',
      page,
      pageSize,
      sort,
      filter,
    ] as const,
    queryFn: async () => {
      const idToken = await getIdToken();
      return getInvitationsPage(apiUrl, idToken, {
        page,
        limit: pageSize,
        sort,
        filter: { ...INVITATIONS_FILTER, ...filter },
      });
    },
    enabled: isSignedIn,
    placeholderData: keepPreviousData,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
